module.exports = __webpack_public_path__ + "static/img/lightbulb.d6e1865.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/homepage/images/lightbulb.png
// module id = BW/C
// module chunks = 1